import React from 'react';
import PropTypes from 'prop-types';

const Light = ({ color }) => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 15 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6.0983 15.1723V19.0603L6.09829 19.1223C6.09825 19.8331 6.09822 20.4498 6.1461 20.895C6.17022 21.1193 6.21465 21.3957 6.32731 21.6478C6.45001 21.9223 6.71628 22.2915 7.21975 22.4024C7.72323 22.5133 8.11997 22.2901 8.34666 22.0925C8.5548 21.9111 8.71123 21.679 8.82735 21.4856C9.05783 21.1017 9.31691 20.542 9.61548 19.897L9.64155 19.8407L11.8949 14.9734L11.9267 14.9047C12.3853 13.9143 12.7746 13.0736 12.9818 12.3838C13.1978 11.6645 13.2916 10.8731 12.8585 10.1298C12.8211 10.0656 12.7811 10.003 12.7385 9.94207C12.246 9.23676 11.4884 8.98933 10.7449 8.88321C10.0502 8.78407 9.15318 8.78155 8.0983 8.78154V4.8936L8.0983 4.83153C8.09834 4.12076 8.09837 3.50403 8.05049 3.05883C8.02637 2.83456 7.98194 2.55817 7.86928 2.3061C7.74658 2.03154 7.48032 1.66235 6.97684 1.55146C6.47336 1.44056 6.07662 1.66373 5.84993 1.86133C5.64179 2.04275 5.48536 2.27489 5.36924 2.46828C5.13876 2.85217 4.87968 3.41185 4.58111 4.05686C4.57245 4.07557 4.56376 4.09434 4.55504 4.11319L2.30166 8.98048L2.26985 9.04918C1.81127 10.0396 1.42204 10.8802 1.21481 11.5701C0.998742 12.2894 0.905013 13.0808 1.33812 13.8241C1.37551 13.8883 1.41553 13.9509 1.45806 14.0118C1.95064 14.7171 2.70818 14.9645 3.4517 15.0706C4.14635 15.1698 5.04341 15.1723 6.0983 15.1723ZM7.61481 8.77521C7.61478 8.7752 7.61512 8.77524 7.61579 8.77534C7.61563 8.77532 7.61547 8.7753 7.61533 8.77528C7.615 8.77524 7.61483 8.77522 7.61481 8.77521Z"
      stroke={color}
      strokeWidth="2"
    />
  </svg>
);

Light.propTypes = {
  color: PropTypes.string.isRequired,
};

export default Light;
